export enum DateFormat {
	DDMMYYYY = 'DD/MM/YYYY',
	MMDDYYYY = 'MM/DD/YYYY',
	YYYYMMDD = 'YYYY/MM/DD',
}
